export interface ActivableRendererProps {
    onMount?: () => void;
    onUnmount?: () => void;
    onActivationFinished?: () => void;
    onDeactivationFinished?: () => void;
}
